<template>
    <DashboardContainer>
        <LeadsGrid/>
        <AddNewLead/>
    </DashboardContainer>
</template>

<script>
import DashboardContainer from '../containers/DashboardContainer'
import LeadsGrid from '../components/leads/LeadsGrid'
import AddNewLead from '../components/leads/AddNewLead'

export default {
    name: 'Leads',
    beforeCreate: function () {
        var auth = this.$storage.get('auth')
        if (!auth) {
            this.$router.push('/login')
        }else{
            if(!auth.token){
                this.$router.push('/login')
            }
        }
    },
    components: {
        DashboardContainer,
        LeadsGrid,
        AddNewLead
    }
}
</script>